import {CaretDownIcon, CaretUpIcon, TableHeaderCellOwnProps} from 'evergreen-ui';
import {Direction, Sort, toggleSort} from 'pagination';
import React, {memo, useCallback} from 'react';
import {BehaviorSubject, Observable} from 'rxjs';
import {useObservable} from 'rxsupport';
import {PolymorphicBoxProps} from 'ui-box/dist/src/types/box-types';
import {ClickableColumnHeader} from '../ClickableColumnHeader';
import {SortableColumn} from './index';

type SortColumnHeaderProps<T> = {
    isRunning$: Observable<boolean>,
    currentSort$: BehaviorSubject<Sort<T>>;
    columnDefinition: SortableColumn<T>;
    buttonClassName?: string;
    disableClick?: boolean;
} & TableHeaderCellOwnProps & PolymorphicBoxProps<'div'>;

export const SortHeader = memo(<T, >({
                                         columnDefinition,
                                         disableClick = false,
                                         currentSort$,
                                         isRunning$,
                                         ...headerProps
                                     }: SortColumnHeaderProps<T>) => {
    const currentSort = useObservable(currentSort$, currentSort$.getValue());
    const loading = useObservable(isRunning$, false);
    const onClick = useCallback(() => {
        currentSort$.next(toggleSort(columnDefinition.name, currentSort$.getValue()));
    }, [currentSort$, columnDefinition])


    const {name, label = name.toString()} = columnDefinition;
    const icon = name === currentSort.by ?
        currentSort.direction === Direction.ASC ? CaretUpIcon :
            currentSort.direction === Direction.DESC ? CaretDownIcon : null : null;

    return (
        <ClickableColumnHeader
            {...headerProps}
            text={label} icon={icon} onClick={disableClick ?  () => {} : onClick} loading={loading}/>
    );
});
